import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { EditorContent, useEditor } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import { BubbleMenu } from '@tiptap/extension-bubble-menu';
import Underline from '@tiptap/extension-underline';
import styled from 'styled-components';
import React, { forwardRef, useEffect, useCallback, useState, useRef } from 'react';
import { CheckOutlined } from '@ant-design/icons';
import { CommentExtension, getNewComment } from '../extensions/comment';
import { Form, Radio, Typography } from 'antd';
import { styleVariables } from '../../../style';
import { PrimaryButton, SecondaryButton } from '../../button';
import { useCommentManager } from '../hooks/use-comment-manager';
import { CommentPopup } from './comment-popup.component';
import ControlledBubbleMenuComment from '../extensions/controlled-bubble-comment';
import TextStyle from '@tiptap/extension-text-style';
import { CustomTextStyle } from '../extensions/custom-text-style';
import { CommentTextArea } from './comment-preview-surface.component';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var StyledLayout = styled.div.withConfig({
  displayName: "editor-commentcomponent__StyledLayout",
  componentId: "sc-1d2iawe-0"
})([".tiptap{margin-bottom:", ";}.my-comment{position:relative;cursor:pointer;transition:box-shadow 0.2s ease;&:hover,&:focus-visible{box-shadow:inset 0 0 0 9999px rgba(15,23,42,0.08);}}custom-class{background-color:", ";}.ProseMirror{padding:", ";border:1px solid ", ";border-radius:", ";}p.is-editor-empty:first-child::before{color:", ";font-style:italic;content:attr(data-placeholder);float:left;height:0;pointer-events:none;}"], styleVariables.margin.large, function (props) {
  return props.theme.color.primary;
}, styleVariables.padding.large, styleVariables.colors.gray9, styleVariables.borderRadius.medium, function (props) {
  return props.theme.color.borderDefault;
});
var StyledEditorContent = styled(EditorContent).withConfig({
  displayName: "editor-commentcomponent__StyledEditorContent",
  componentId: "sc-1d2iawe-1"
})(["max-height:", ";overflow-y:", ";& > *{pointer-events:", ";}"], function (props) {
  return props.scrollable ? '70vh' : 'none';
}, function (props) {
  return props.scrollable ? 'auto' : 'visible';
}, function (props) {
  return props.disabled && 'none';
});
var StyledCommentWrapper = styled.div.withConfig({
  displayName: "editor-commentcomponent__StyledCommentWrapper",
  componentId: "sc-1d2iawe-2"
})(["box-sizing:border-box;display:flex;flex-direction:column;width:400px;max-width:calc(100vw - 32px);padding:18px;border:1px solid ", ";border-radius:16px;background-color:", ";box-shadow:0 12px 30px rgba(15,23,42,0.16);h4{margin:0 0 8px;color:", ";font-size:14px;font-weight:700;letter-spacing:0.04em;text-transform:uppercase;}.ant-form-item{margin-bottom:12px;}.ant-form-item-label > label{height:32px;color:", ";font-size:14px;}"], styleVariables.colors.gray9, function (props) {
  return props.theme.color.backgroundPrimary;
}, function (props) {
  return props.theme.color.fontColorSecondary;
}, function (props) {
  return props.theme.color.fontColorSecondary;
});
var StyledSelectedTextPreview = styled.div.withConfig({
  displayName: "editor-commentcomponent__StyledSelectedTextPreview",
  componentId: "sc-1d2iawe-3"
})(["box-sizing:border-box;overflow:hidden;width:100%;max-width:100%;max-height:56px;margin-bottom:10px;padding:", " 10px;border-radius:", ";background:", ";"], styleVariables.padding.medium, styleVariables.borderRadius.medium, styleVariables.highlightColors.color1);
var StyledSelectedText = styled(Typography.Text).withConfig({
  displayName: "editor-commentcomponent__StyledSelectedText",
  componentId: "sc-1d2iawe-4"
})(["&&{display:-webkit-box;overflow:hidden;width:100%;max-width:100%;max-height:40px;color:", ";font-family:Georgia,serif;font-size:13px;font-style:italic;line-height:20px;overflow-wrap:anywhere;text-overflow:ellipsis;white-space:normal;word-break:break-word;-webkit-box-orient:vertical;-webkit-line-clamp:2;}"], function (props) {
  return props.theme.color.fontColorSecondary;
});
var StyledColorGroup = styled(Radio.Group).withConfig({
  displayName: "editor-commentcomponent__StyledColorGroup",
  componentId: "sc-1d2iawe-5"
})(["display:flex;gap:10px;"]);
var StyledGroupButton = styled.div.withConfig({
  displayName: "editor-commentcomponent__StyledGroupButton",
  componentId: "sc-1d2iawe-6"
})(["display:flex;justify-content:flex-end;gap:", ";"], styleVariables.margin.small);
var StyledFooter = styled.div.withConfig({
  displayName: "editor-commentcomponent__StyledFooter",
  componentId: "sc-1d2iawe-7"
})(["display:flex;align-items:center;justify-content:space-between;gap:12px;"]);
var StyledButton = styled(Radio.Button).withConfig({
  displayName: "editor-commentcomponent__StyledButton",
  componentId: "sc-1d2iawe-8"
})(["display:inline-flex;align-items:center;justify-content:center;width:32px;height:32px;padding:0;border:1px solid ", " !important;border-radius:50% !important;background:", " !important;color:", ";&::before{display:none !important;}svg{opacity:0;}&.ant-radio-button-wrapper-checked{box-shadow:0 0 0 3px ", ",0 0 0 5px ", ";svg{opacity:1;}}"], function (props) {
  return props.$color;
}, function (props) {
  return props.$color;
}, function (props) {
  return props.theme.color.fontColorSecondary;
}, function (props) {
  return props.theme.color.backgroundPrimary;
}, function (props) {
  return props.theme.color.borderDefault;
});
var StyledCharacterCount = styled.div.withConfig({
  displayName: "editor-commentcomponent__StyledCharacterCount",
  componentId: "sc-1d2iawe-9"
})(["color:", ";font-size:12px;white-space:nowrap;"], function (props) {
  return props.theme.color.fontColorSecondary;
});
var highlightColors = [styleVariables.highlightColors.color1, styleVariables.highlightColors.color2, styleVariables.highlightColors.color3, styleVariables.highlightColors.color4, styleVariables.highlightColors.color5];
export var EditorComment = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var onChange = _ref.onChange,
      content = _ref.content,
      showComment = _ref.showComment,
      disabled = _ref.disabled,
      _ref$scrollable = _ref.scrollable,
      scrollable = _ref$scrollable === void 0 ? false : _ref$scrollable,
      onAnswerComment = _ref.onAnswerComment,
      comments = _ref.comments,
      setComments = _ref.setComments,
      onDeleteAnswerComment = _ref.onDeleteAnswerComment,
      onUpdateAnswerComment = _ref.onUpdateAnswerComment,
      labels = _ref.labels,
      _ref$loadingComment = _ref.loadingComment,
      loadingComment = _ref$loadingComment === void 0 ? false : _ref$loadingComment;

  var _useCommentManager = useCommentManager({
    comments: comments,
    setComments: setComments
  }),
      hoveredCommentId = _useCommentManager.hoveredCommentId,
      popupPosition = _useCommentManager.popupPosition,
      preview = _useCommentManager.preview,
      isEditingComment = _useCommentManager.isEditingComment,
      commentValue = _useCommentManager.commentValue,
      handleCommentActivated = _useCommentManager.handleCommentActivated,
      showCommentPreview = _useCommentManager.showCommentPreview,
      handleCommentEdit = _useCommentManager.handleCommentEdit,
      handleCommentDelete = _useCommentManager.handleCommentDelete,
      handleCommentUpdate = _useCommentManager.handleCommentUpdate,
      handleCancelUpdateComment = _useCommentManager.handleCancelUpdateComment,
      closeCommentPreview = _useCommentManager.closeCommentPreview,
      setCommentValue = _useCommentManager.setCommentValue;

  var _Form$useForm = Form.useForm(),
      _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
      form = _Form$useForm2[0];

  var _useState = useState(false),
      editable = _useState[0],
      setEditable = _useState[1];

  var _useState2 = useState(''),
      selectedText = _useState2[0],
      setSelectedText = _useState2[1];

  var commentContent = Form.useWatch('content', form) || '';
  var editor = useEditor({
    extensions: [StarterKit, Underline, BubbleMenu, TextStyle, CustomTextStyle, CommentExtension.configure({
      HTMLAttributes: {
        "class": 'my-comment'
      },
      onCommentActivated: handleCommentActivated
    })],
    content: content || '',
    onUpdate: function onUpdate() {
      onChange === null || onChange === void 0 ? void 0 : onChange(editor.getHTML());
    }
  });
  useEffect(function () {
    if (!editor) return;
    return function () {
      return editor.destroy();
    };
  }, [editor]);
  useEffect(function () {
    if (editor) {
      editor.setEditable(editable);
    }
  }, [editable, editor]);
  useEffect(function () {
    if (!editor) return;

    var updateSelectedText = function updateSelectedText() {
      setSelectedText(editor.state.doc.textBetween(editor.state.selection.from, editor.state.selection.to, ' '));
    };

    editor.on('selectionUpdate', updateSelectedText);
    return function () {
      editor.off('selectionUpdate', updateSelectedText);
    };
  }, [editor]);
  var getHighlightPreview = useCallback(function (element) {
    var _element$closest;

    var commentId = element.dataset.commentId;
    if (!commentId) return null;
    var rect = element.getBoundingClientRect();
    var selectedCommentText = Array.from(((_element$closest = element.closest('.ProseMirror')) === null || _element$closest === void 0 ? void 0 : _element$closest.querySelectorAll('[data-comment-id]')) || []).filter(function (item) {
      return item.dataset.commentId === commentId;
    }).map(function (item) {
      return item.textContent || '';
    }).join('');
    return {
      id: commentId,
      text: selectedCommentText || element.textContent || '',
      color: element.dataset.commentColor || styleVariables.highlightColors.color1,
      position: {
        top: rect.bottom + 10,
        left: Math.max(12, Math.min(rect.left, window.innerWidth - 380))
      }
    };
  }, []);
  var handleHighlightClick = useCallback(function (event) {
    var element = event.target.closest('[data-comment-id]');
    if (!element) return;
    var preview = getHighlightPreview(element);
    if (preview) showCommentPreview(preview);
  }, [getHighlightPreview, showCommentPreview]);
  var handleSave = useCallback(function (value) {
    var commentContent = value.content.trim();
    if (!commentContent || !editor) return;
    var newComment = getNewComment(commentContent);
    editor.commands.setComment(newComment.id, value.color);
    setEditable(true);
    setComments(function (prev) {
      return [].concat(_toConsumableArray(prev), [newComment]);
    });
    onAnswerComment === null || onAnswerComment === void 0 ? void 0 : onAnswerComment(newComment.id, commentContent, editor.getHTML());
    form.resetFields();
    setEditable(false);
  }, [form, editor, onAnswerComment, setComments]);
  var handleCancel = useCallback(function () {
    form.resetFields();
    setSelectedText('');

    if (editor) {
      editor.commands.setTextSelection(editor.state.selection.to);
      editor.commands.blur();
    }
  }, [editor, form]);
  var handleCommentShortcut = useCallback(function (event) {
    if ((event.metaKey || event.ctrlKey) && event.key === 'Enter' && commentContent.trim()) {
      event.preventDefault();
      form.submit();
    }
  }, [commentContent, form]);
  var handleDeleteComment = useCallback(function (commentId, editor) {
    if (commentId) {
      editor.commands.unsetComment(commentId);
      setComments(function (prev) {
        return prev.filter(function (comment) {
          return comment.id !== commentId;
        });
      });
      onDeleteAnswerComment === null || onDeleteAnswerComment === void 0 ? void 0 : onDeleteAnswerComment(commentId, editor.getHTML());
      handleCommentDelete();
    }
  }, [handleCommentDelete, onDeleteAnswerComment, setComments]);
  var prevLoadingRef = useRef(loadingComment);
  useEffect(function () {
    if (prevLoadingRef.current && !loadingComment) {
      handleCommentUpdate();
    }

    prevLoadingRef.current = loadingComment;
  }, [loadingComment, handleCommentUpdate]);
  var handleSaveUpdateComment = useCallback(function (commentId, content, editor) {
    var nextContent = content.trim();

    if (commentId && nextContent) {
      setComments(function (prev) {
        return prev.map(function (comment) {
          return comment.id === commentId ? _objectSpread(_objectSpread({}, comment), {}, {
            content: nextContent
          }) : comment;
        });
      });
      onUpdateAnswerComment === null || onUpdateAnswerComment === void 0 ? void 0 : onUpdateAnswerComment(commentId, nextContent, editor.getHTML());
    }
  }, [onUpdateAnswerComment, setComments]);

  var updateCommentChange = function updateCommentChange(value) {
    setCommentValue(value);
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(StyledLayout, {
      ref: ref,
      onClick: handleHighlightClick,
      children: [/*#__PURE__*/_jsx(StyledEditorContent, {
        editor: editor,
        disabled: disabled,
        scrollable: scrollable,
        contentEditable: false
      }), /*#__PURE__*/_jsx(CommentPopup, {
        position: popupPosition,
        commentId: hoveredCommentId,
        content: commentValue,
        isEditing: isEditingComment,
        onEdit: handleCommentEdit,
        onDelete: function onDelete(commentId) {
          return handleDeleteComment(commentId, editor);
        },
        onSave: function onSave(commentId, content) {
          return handleSaveUpdateComment(commentId, content, editor);
        },
        onCancel: handleCancelUpdateComment,
        onClose: closeCommentPreview,
        onUpdateContent: updateCommentChange,
        labels: labels,
        loading: loadingComment,
        selectedText: preview === null || preview === void 0 ? void 0 : preview.text,
        highlightColor: preview === null || preview === void 0 ? void 0 : preview.color
      })]
    }), editor && showComment && /*#__PURE__*/_jsx(ControlledBubbleMenuComment, {
      editor: editor,
      tippyOptions: {
        hideOnClick: false
      },
      children: /*#__PURE__*/_jsx(StyledCommentWrapper, {
        onClick: function onClick(event) {
          return event.stopPropagation();
        },
        children: /*#__PURE__*/_jsxs(Form, {
          name: "comment-form",
          form: form,
          initialValues: {
            color: highlightColors[0],
            content: ''
          },
          onFinish: handleSave,
          children: [/*#__PURE__*/_jsx("h4", {
            children: labels.comment
          }), /*#__PURE__*/_jsx(StyledSelectedTextPreview, {
            children: /*#__PURE__*/_jsxs(StyledSelectedText, {
              children: ["\u201C", selectedText]
            })
          }), /*#__PURE__*/_jsx(Form.Item, {
            name: "color",
            label: "".concat(labels.selectColor, ":"),
            children: /*#__PURE__*/_jsx(StyledColorGroup, {
              children: highlightColors.map(function (color) {
                return /*#__PURE__*/_jsx(StyledButton, {
                  value: color,
                  $color: color,
                  children: /*#__PURE__*/_jsx(CheckOutlined, {})
                }, color);
              })
            })
          }), /*#__PURE__*/_jsx(Form.Item, {
            name: "content",
            children: /*#__PURE__*/_jsx(CommentTextArea, {
              rows: 4,
              maxLength: 750,
              placeholder: labels.enterComment || labels.comment,
              onKeyDown: handleCommentShortcut
            })
          }), /*#__PURE__*/_jsxs(StyledFooter, {
            children: [/*#__PURE__*/_jsxs(StyledCharacterCount, {
              children: [commentContent.length, "/750 \xB7 ", labels.shortcutToSave || '⌘↵ to save']
            }), /*#__PURE__*/_jsxs(StyledGroupButton, {
              children: [/*#__PURE__*/_jsx(SecondaryButton, {
                onClick: handleCancel,
                disabled: loadingComment,
                children: labels.cancel
              }), /*#__PURE__*/_jsx(PrimaryButton, {
                type: "primary",
                htmlType: "submit",
                loading: loadingComment,
                disabled: !commentContent.trim(),
                children: labels.save
              })]
            })]
          })]
        })
      })
    })]
  });
});